<div class="component-card">
    <div>
        <h1 class="component-title">{{'SYSTEM_PROFILES.MY_PROFILE'|translate}}</h1>
        <i class="pi pi-ellipsis-v spam-menu" (click)="menu.toggle($event)"></i>
        <p-menu #menu class="edit-menu" [popup]="true" [model]="items"></p-menu>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="d-flex flex-row" style="align-items: self-end;width: 50%;">
                <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file"
                    id="openFile" #openFile name="openFile" accept="image/png, image/jpg, image/jpeg" />
                <img class="admin_picture" [src]="userProfileModel.profilePictureUrl" alt="profile-picture">
                <div *ngIf="!enableEdit" class="admin_info ">
                    <h5 class="title"><span>{{userProfileModel.firstName}}
                        </span><span>{{userProfileModel.lastName}}</span></h5>
                    <div class="admin_role">
                        <i class="pi pi-user"></i>
                        <span> {{userProfileModel.roleName}} </span>
                    </div>
                </div>
                <div *ngIf="enableEdit" class="picture-edit">
                    <div (click)="openAddImage()" class="d-flex flex-row">
                        <i class="pi pi-pencil"></i>
                        <p class="m-0">{{ 'PERSONAL_PROFILE.CHANGE_PICTURE' | translate }}</p>
                    </div>
                    <label class="pictureError" *ngIf="pictureIsWrongFormat">{{ 'VENUES.PICTURE_IS_WRONG_FORMAT'
                        |translate}}</label>
                </div>
            </div>

            <div style="width: 50%; ">
                <label style="margin-top: 0px;" class="title_label">{{ 'SYSTEM_PROFILES.EMAIL' | translate | uppercase}}</label>
                <input type="text" disabled class="input_text_field" [(ngModel)]="userProfileModel.email">
            </div>
        </div>
        <div class="d-flex flex-row justify-content-between pb-4">
            <div *ngIf="enableEdit" style="width: 50%; ">
                <label style="margin-top: 0px;" class="title_label">{{ 'SYSTEM_PROFILES.FIRST_NAME' | translate | uppercase}}
                    <i class="pi pi-pencil float-end"></i>
                    <i *ngIf="errorModel!=null && errorModel['FirstName']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color"
                        pTooltip="{{errorModel['FirstName']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="text" disabled="{{!enableEdit}}" class="input_text_field"
                    [(ngModel)]="userProfileModel.firstName">
            </div>
            <div *ngIf="enableEdit" style="width: 50%; ">
                <label style="margin-top: 0px;" class="title_label">{{ 'SYSTEM_PROFILES.LAST_NAME' | translate | uppercase}}
                    <i class="pi pi-pencil float-end"></i>
                    <i *ngIf="errorModel!=null && errorModel['LastName']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color"
                        pTooltip="{{errorModel['LastName']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="text" disabled="{{!enableEdit}}" class="input_text_field"
                    [(ngModel)]="userProfileModel.lastName">
            </div>
            <div style="width: 50%; ">
                <label style="margin-top: 0px;" class="title_label">{{ 'SYSTEM_PROFILES.BIRTHDAY' | translate | uppercase}}
                    <i *ngIf="enableEdit" class="pi pi-pencil float-end"></i>
                    <i *ngIf="errorModel!=null && errorModel['DateOfBirth']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color"
                        pTooltip="{{errorModel['DateOfBirth']|translate}}" tooltipPosition="top"></i>
                </label>
                <input *ngIf="!enableEdit" type="text" disabled="{{!enableEdit}}" class="input_text_field"
                    [(ngModel)]="dateOfBirth">
                <p-calendar *ngIf="enableEdit" [(ngModel)]="userProfileModel.dateOfBirth" dateFormat="dd/mm/yy"
                    [showIcon]="true"></p-calendar>
            </div>
            <div style="width: 50%; ">
                <label style="margin-top: 0px;" class="title_label">{{ 'SYSTEM_PROFILES.PHONE' | translate | uppercase}}
                    <i *ngIf="enableEdit" class="pi pi-pencil float-end"></i>
                    <i *ngIf="errorModel!=null && errorModel['Phone']!=null"
                        class="pi pi-exclamation-circle float-end me-1 error_color"
                        pTooltip="{{errorModel['Phone']|translate}}" tooltipPosition="top"></i>
                </label>
                <input type="text" disabled="{{!enableEdit}}" class="input_text_field"
                    [(ngModel)]="userProfileModel.phone">
            </div>
        </div>
        <div *ngIf="enableEdit" class="d-flex flex-row justify-content-between pb-4">
            <button class="btn_in_color" (click)="updateUserProfile(userProfileModel)">{{ 'SAVE_CHANGES' |
                translate}}</button>
            <button class="btn_without_color" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
        </div>
    </div>

</div>
